import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const userManagementApi = createApi({
    reducerPath: 'userManagementApi',
    baseQuery: baseQuery, // Replace '/api' with your actual API base URL
    tagTypes: ['Users'],
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => '/admin/user_management/users',
            method: 'GET',
            providesTags: ['Users'],
        }),
        deleteUser: builder.mutation({
            query: (id) => ({
                url: `/admin/user_management/users/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Users'],
        }),
        updateUserAccessLevel: builder.mutation({
            query: ({ accessLevel, userEmail, clientName }) => ({
                url: `/admin/user_management/user_access`,
                method: 'PUT',
                body: { 
                    "user_email": userEmail,
                    "access_level": accessLevel,
                    "client_name": clientName
                 },
            }),
            invalidatesTags: ['Users'],
        }),
    }),
});

export const { useGetUsersQuery, useDeleteUserMutation, useUpdateUserAccessLevelMutation } = userManagementApi;

export default userManagementApi.reducer;